import { useState, useEffect } from 'react';

export interface ComparisonLimits {
  maxComparisons: number;
  currentComparisons: number;
  canAddMore: boolean;
  resetComparisons: () => void;
}

export const useComparisonLimits = () => {
  const [currentComparisons, setCurrentComparisons] = useState(0);

  // Traffic-first model: unlimited metro/occupation comparisons for everyone.
  const maxComparisons = Infinity;
  
  // Load comparison count from sessionStorage
  useEffect(() => {
    const stored = sessionStorage.getItem('comparison_count');
    if (stored) {
      setCurrentComparisons(parseInt(stored, 10));
    }
  }, []);

  // Save to sessionStorage when count changes
  useEffect(() => {
    sessionStorage.setItem('comparison_count', currentComparisons.toString());
  }, [currentComparisons]);

  const incrementComparisons = () => {
    setCurrentComparisons(prev => Math.min(prev + 1, maxComparisons));
  };

  const resetComparisons = () => {
    setCurrentComparisons(0);
    sessionStorage.removeItem('comparison_count');
  };

  const canAddMore = currentComparisons < maxComparisons;

  return {
    maxComparisons,
    currentComparisons,
    canAddMore,
    incrementComparisons,
    resetComparisons
  };
};